var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusTop"},[_c('div',{staticClass:""},[_c('img',{attrs:{"src":"static\\imgs\\pc\\personal-logo.svg","alt":""}})]),_vm._v(" "),_c('p',[_vm._v("以下填写信息将录入电子合同，望真诚交易，虚假填写触发合同违约，后果自负。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fac33050","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/centLogo.vue
// module id = null
// module chunks = 